import RaikoGridOneColumn from "../raikoCustomGrids/RaikoGridOneColumn";
import {useEffect} from "react";
import {css} from "@emotion/css";
import "./RaikoCollapsibleStyleSheet.scss"

export const RaikoCollapsibleTableContainer = ({children}) => {

    useEffect(() => {

    }, [])


    return (
        <>
            <RaikoGridOneColumn className={"childrenContainer"}>
                {children}
            </RaikoGridOneColumn>
        </>
    )
}